import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ChevronLeft, Menu } from "lucide-react";
import { Logo } from "@/components/brand/Logo";
import { NotificationBell } from "@/components/notifications/NotificationBell";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { NavList } from "./NavList";
import { ThemeToggle } from "./ThemeToggle";
import { UserMenu } from "./UserMenu";

export const MobileTopbar = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const canGoBack = (window.history.state?.idx ?? 0) > 0;
  const isHome = location.pathname === "/" && !location.search;
  const goBack = () => (canGoBack ? navigate(-1) : navigate("/"));
  return (
    <header style={{ paddingTop: "env(safe-area-inset-top)", height: "calc(4rem + env(safe-area-inset-top))" }} className="md:hidden print:hidden sticky top-0 z-30 flex items-center justify-between border-b border-brand-gold/20 dark:border-brand-line bg-background/85 backdrop-blur-xl px-4">
      <div className="flex min-w-0 items-center gap-1">
        <button type="button" onClick={goBack} disabled={!canGoBack && isHome} data-testid="mobile-back-button" aria-label="Indietro"
          className="-ml-2 inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-xl hover:bg-accent active:scale-95 disabled:opacity-30">
          <ChevronLeft className="h-6 w-6" />
        </button>
        <Logo variant="wordmark" className="h-7 w-auto" testId="mobile-logo" />
      </div>
      <div className="flex items-center gap-1">
        <NotificationBell />
        <ThemeToggle compact className="w-10 justify-center px-0" />
        <Sheet open={open} onOpenChange={setOpen}>
          <SheetTrigger asChild>
            <button type="button" data-testid="mobile-menu-button" aria-label="Apri menu" className="inline-flex h-11 w-11 items-center justify-center rounded-xl hover:bg-accent">
              <Menu className="h-5 w-5" />
            </button>
          </SheetTrigger>
          <SheetContent side="left" className="w-[280px] p-0 flex flex-col" data-testid="mobile-menu-sheet">
            <SheetHeader className="px-6 pb-6 text-left" style={{ paddingTop: "calc(env(safe-area-inset-top) + 2rem)" }}>
              <SheetTitle className="sr-only">Menu</SheetTitle>
              <Logo variant="wordmark" className="h-8 w-auto" testId="mobile-sheet-logo" />
            </SheetHeader>
            <div className="gold-rule mx-6" />
            <div className="flex-1 overflow-y-auto px-4 py-5">
              <NavList onNavigate={() => setOpen(false)} />
            </div>
            <div className="gold-rule mx-6" />
            <div className="p-4"><UserMenu /></div>
          </SheetContent>
        </Sheet>
      </div>
    </header>
  );
};
